export default __webpack_public_path__ + "static/media/platinum-award-winner-1.c09ece3e.png";